import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-dark font-weight-bold" }
const _hoisted_2 = { class: "row mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LabelAndValue = _resolveComponent("LabelAndValue")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!

  return (_openBlock(), _createBlock(_component_q_expansion_item, {
    "default-opened": "",
    "expand-icon-toggle": "",
    "header-class": "align-items-center justify-content-between mb-3 mt-3 bg-white",
    class: "bg-white"
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.capitalize(_ctx.$t("summaryPanel.cotation.title").toLowerCase())), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleRatings, (rating, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-6 mb-2",
            key: (rating.type || 'rating') + '-' + index
          }, [
            _createVNode(_component_LabelAndValue, {
              label: _ctx.ratingLabel(rating.type),
              value: _ctx.ratingDisplayValue(rating),
              oneLine: true,
              "value-style": _ctx.valueStyle,
              "label-style": _ctx.labelStyleItem,
              "div-value-style": _ctx.divValueStyle
            }, null, 8, ["label", "value", "value-style", "label-style", "div-value-style"])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }))
}